import React from 'react';
import { Typography, Box, Paper, Button } from '@mui/material';
import logo from '../../assets/icon.svg';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { pageAtom, isBackdropOpenAtom, snackbarPropsAtom } from '../../atoms';
import { PAGE } from '../../constant/page';

import { CustomImage as TopconectLogo } from '../../sharedComponents';
import { ApiAccountsResendActivation } from '../../api/apiAccountsResendActivation';
import { ApiAccountsResetPassword } from '../../api/apiAccountsResetPassword';
import {
  reActivationMailAtom,
  resetPasswordMailAtom,
  registerMailAtom,
} from '../../atoms/emailAtoms';

const boxStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '80px',
};

const paperStyles = {
  width: '50%',
  maxWidth: '700px',
  paddingX: '100px',
  paddingY: '50px',
};

const SentEmailPage = () => {
  const [page, setPage] = useAtom(pageAtom);
  const setIsBackdropOpen = useSetAtom(isBackdropOpenAtom);
  const setSnackbarPropsAtom = useSetAtom(snackbarPropsAtom);

  let emailAtom;
  switch (page) {
    case PAGE.REACTIVATION_MAIL:
      emailAtom = reActivationMailAtom;
      break;
    case PAGE.CHANGE_PASSWORD_MAIL:
      emailAtom = resetPasswordMailAtom;
      break;
    case PAGE.REGISTRATION_MAIL:
      emailAtom = registerMailAtom;
      break;
    default:
      emailAtom = reActivationMailAtom;
      break;
  }
  const email = useAtomValue(emailAtom);

  const onClickReSendMail = async () => {
    let ApiAccountsResend;
    if (page === PAGE.CHANGE_PASSWORD_MAIL) {
      ApiAccountsResend = ApiAccountsResetPassword;
    } else {
      ApiAccountsResend = ApiAccountsResendActivation;
    }

    setIsBackdropOpen(true);
    await ApiAccountsResend.post(email)
      .then(() => {
        setSnackbarPropsAtom({
          isOpen: true,
          message: 'メールが送信されました。',
          type: 'success',
        });
      })
      .catch((error) => {
        console.log(error);
        setSnackbarPropsAtom({
          isOpen: true,
          message: 'メールの送信に失敗しました。',
          type: 'error',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  const onClickPreview = () => {
    switch (page) {
      case PAGE.CHANGE_PASSWORD_MAIL:
        setPage(PAGE.CHANGE_PASSWORD);
        break;
      case PAGE.REACTIVATION_MAIL:
        setPage(PAGE.REACTIVATION);
        break;
    }
  };

  return (
    <Box {...boxStyles}>
      <Paper elevation={3} sx={paperStyles}>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          gap='50px'
        >
          <TopconectLogo src={logo} alt='logo' width='200px' />
          {page === PAGE.REGISTRATION_MAIL ? (
            <Typography variant='h5'>
              {'ご登録ありがとうございます。'}
            </Typography>
          ) : (
            <></>
          )}
          <Typography variant='h6'>
            {page === PAGE.CHANGE_PASSWORD_MAIL
              ? 'パスワード変更用のメールを送信しました。メール内のリンクからパスワードを変更してください。'
              : 'アクティベーション用のメールを送信しました。メール内のリンクからアクティベーションを完了してください。'}
          </Typography>
          <Typography
            sx={{
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            color='Highlight'
            variant='h6'
            onClick={onClickReSendMail}
          >
            {page === PAGE.CHANGE_PASSWORD_MAIL
              ? 'パスワード変更用のメールを再送する'
              : 'アクティベーション用のメールを再送する'}
          </Typography>{' '}
          <Box
            display={'flex'}
            justifyContent={'center'}
            columnGap={5}
            marginBottom={5}
          >
            {page === PAGE.REGISTRATION_MAIL ? (
              <></>
            ) : (
              <Button
                variant='contained'
                sx={{ minWidth: '150px' }}
                color='inherit'
                onClick={onClickPreview}
              >
                {'戻る'}
              </Button>
            )}
            <Button
              variant='contained'
              sx={{ minWidth: '150px' }}
              color='primary'
              onClick={() => {
                setPage(PAGE.LOGIN);
              }}
            >
              {'OK'}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(SentEmailPage);
